export default __webpack_public_path__ + "static/media/vitejs.b99f0b09.svg";